export const meta = {
	title: "All Spell API Guides"
};

# Spell API Guides

Every spell you write pulls in one or more of these APIs with `require(...)`. Pick a guide below to learn what each spell can do, how to import it, and how to configure it.

## Offensive Spells

- [Projectile API Guide](spell-api-guides/projectile-api-guide) — a configurable projectile with optional homing and steering
- [Fire API Guide](spell-api-guides/fire-api-guide) — fireballs, fire blasts, and fire waves
- [Air API Guide](spell-api-guides/air-api-guide) — shove entities with a burst of wind

## Conjuring & Defense

- [Earth API Guide](spell-api-guides/earth-api-guide) — conjure a solid stone block from a shape
- [Ice API Guide](spell-api-guides/ice-api-guide) — conjure a solid ice block from a shape
- [Heal API Guide](spell-api-guides/heal-api-guide) — restore health, instantly or over time
- [Grapple API Guide](spell-api-guides/grapple-api-guide) — a spring line to a point or entity
- [Area Preview API Guide](spell-api-guides/area-preview-api-guide) — draw a translucent overlay in the world

## Detection & The World

- [Sensor API Guide](spell-api-guides/sensor-api-guide) — continuously detect entities within a radius
- [Ping API Guide](spell-api-guides/ping-api-guide) — a one-shot detection ping
- [Get Entities API Guide](spell-api-guides/get-entities-api-guide) — list every entity in the level
- [Terrain API Guide](spell-api-guides/terrain-api-guide) — line-of-sight checks and nav-grid sampling
- [Aim API Guide](spell-api-guides/aim-api-guide) — aim a point with the cursor

## Mana & Casting

- [Spark API Guide](spell-api-guides/spark-api-guide) — a floating ManaSpark that casts spells
- [Spells API Guide](spell-api-guides/spells-api-guide) — inspect, save, and run other spells

## Player & Interface

- [Player Controls API Guide](spell-api-guides/player-controls-api-guide) — drive the player's jump, movement, and attacks
- [Player Inventory API Guide](spell-api-guides/player-inventory-api-guide) — read and manage inventory and hotkeys
- [Tabs API Guide](spell-api-guides/tabs-api-guide) — open, close, move, and resize UI panels

## Utilities

- [Self API Guide](spell-api-guides/self-api-guide) — the entity casting the spell
- [Wait API Guide](spell-api-guides/wait-api-guide) — pause execution without blocking the game
- [Speed API Guide](spell-api-guides/speed-api-guide) — control interpreter execution speed
- [Vector API Guide](spell-api-guides/vector-api-guide) — 2D vector math helpers
- [Shapes API Guide](spell-api-guides/shapes-api-guide) — build polygon outlines for earth/ice
- [Info API Guide](spell-api-guides/info-api-guide) — inspect any module or entity for discovery
